__turbopack_context__.v({
  "audioControls": "audio-player-module-scss-module__12BHWq__audioControls",
  "audioElement": "audio-player-module-scss-module__12BHWq__audioElement",
  "audioPlayer": "audio-player-module-scss-module__12BHWq__audioPlayer",
  "backControls": "audio-player-module-scss-module__12BHWq__backControls",
  "body": "audio-player-module-scss-module__12BHWq__body",
  "controlsWrapper": "audio-player-module-scss-module__12BHWq__controlsWrapper",
  "coverImage": "audio-player-module-scss-module__12BHWq__coverImage",
  "currentTime": "audio-player-module-scss-module__12BHWq__currentTime",
  "ergonomic": "audio-player-module-scss-module__12BHWq__ergonomic",
  "forwardControls": "audio-player-module-scss-module__12BHWq__forwardControls",
  "headings": "audio-player-module-scss-module__12BHWq__headings",
  "imageSection": "audio-player-module-scss-module__12BHWq__imageSection",
  "imageWrapper": "audio-player-module-scss-module__12BHWq__imageWrapper",
  "isActive": "audio-player-module-scss-module__12BHWq__isActive",
  "isPlaying": "audio-player-module-scss-module__12BHWq__isPlaying",
  "mediaSection": "audio-player-module-scss-module__12BHWq__mediaSection",
  "micro-player": "audio-player-module-scss-module__12BHWq__micro-player",
  "mini-player": "audio-player-module-scss-module__12BHWq__mini-player",
  "pauseIcon": "audio-player-module-scss-module__12BHWq__pauseIcon",
  "play": "audio-player-module-scss-module__12BHWq__play",
  "playIcon": "audio-player-module-scss-module__12BHWq__playIcon",
  "playWrapper": "audio-player-module-scss-module__12BHWq__playWrapper",
  "playlist": "audio-player-module-scss-module__12BHWq__playlist",
  "playlistTitle": "audio-player-module-scss-module__12BHWq__playlistTitle",
  "playlistTrack": "audio-player-module-scss-module__12BHWq__playlistTrack",
  "playlistTrackThumbnail": "audio-player-module-scss-module__12BHWq__playlistTrackThumbnail",
  "playlistTrackTitle": "audio-player-module-scss-module__12BHWq__playlistTrackTitle",
  "progressBar": "audio-player-module-scss-module__12BHWq__progressBar",
  "remainingTime": "audio-player-module-scss-module__12BHWq__remainingTime",
  "scrubberWrapper": "audio-player-module-scss-module__12BHWq__scrubberWrapper",
  "seekBack": "audio-player-module-scss-module__12BHWq__seekBack",
  "seekForward": "audio-player-module-scss-module__12BHWq__seekForward",
  "subtitle": "audio-player-module-scss-module__12BHWq__subtitle",
  "timeButtons": "audio-player-module-scss-module__12BHWq__timeButtons",
  "timeControls": "audio-player-module-scss-module__12BHWq__timeControls",
  "title": "audio-player-module-scss-module__12BHWq__title",
  "transcript": "audio-player-module-scss-module__12BHWq__transcript",
  "transcriptFalse": "audio-player-module-scss-module__12BHWq__transcriptFalse",
  "transcriptIsOpen": "audio-player-module-scss-module__12BHWq__transcriptIsOpen",
  "transcriptSection": "audio-player-module-scss-module__12BHWq__transcriptSection",
  "transcriptToggle": "audio-player-module-scss-module__12BHWq__transcriptToggle",
  "transcriptToggleIcon": "audio-player-module-scss-module__12BHWq__transcriptToggleIcon",
  "transcriptToggleText": "audio-player-module-scss-module__12BHWq__transcriptToggleText",
  "transcriptTrue": "audio-player-module-scss-module__12BHWq__transcriptTrue",
  "transcriptWrapper": "audio-player-module-scss-module__12BHWq__transcriptWrapper",
});
